import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'react-i18next';
import ReactTableContainer from 'react-table-container';

import { Helmet } from 'react-helmet';

import { connect } from 'react-redux';

import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Media from 'reactstrap/lib/Media';
import Button from 'reactstrap/lib/Button';

import LevelProgress from './LevelProgress';
import GiftsHistory from './GiftsHistory';
// import Friends from './Friends';
import * as constants from '../../../constants/constants';

import myInfoImg from '../../../images/icons/my_profile.png';

import { removeGift, getGiftsHistory, setUserScreenViewNew } from '../../../actions/member';
import { renderNum } from '../../../utils/stringUtils';
import { changeDateFormat } from '../../../utils/dateUtils';

class MyInfo extends Component {
  static propTypes = {
    member: PropTypes.shape().isRequired,
    i18n: PropTypes.shape().isRequired,
    myTournamentsData: PropTypes.shape({
      name: PropTypes.string,
      position: PropTypes.number,
      points: PropTypes.number,
    }),
    //  leaderboardData: PropTypes.arrayOf(PropTypes.shape()),
    achievementsNotification: PropTypes.bool,
    gifts: PropTypes.shape(),
    notificationSettings: PropTypes.shape(),
    getGiftsHistoryFunction: PropTypes.func.isRequired,
    removeGiftFunction: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    changeTab: PropTypes.func.isRequired,
    fontMode: PropTypes.string,
    setScreenViewNew: PropTypes.func.isRequired,
  }

  static defaultProps = {
    myTournamentsData: {},
    achievementsNotification: false,
    gifts: {},
    notificationSettings: {},
    fontMode: constants.FONT_MODE.normal,
  //  leaderboardData: {},
  }

  constructor(props) {
    super(props);
    this.state = {
    //  leaderboardPosition: '',
    };
  }
  componentDidMount() {
    const { setScreenViewNew } = this.props;
    setScreenViewNew(constants.SCREENS.MY_INFO.MY_INFO);
  }

  render() {
    const {
      fontMode, member, t, myTournamentsData, changeTab, achievementsNotification, gifts, i18n, removeGiftFunction, getGiftsHistoryFunction, notificationSettings, userTournamentsHistory,
    } = this.props;

    console.log('userTournamentsHistory', { userTournamentsHistory });

    return (
      <div className="my-info d-flex flex-column">
        <Helmet>
          <title>
            Zole - {t('route.myInfo')}
          </title>
        </Helmet>

        <Row className="my-info-header">
          <Col xs="3" className="pr-0">
            <Media src={myInfoImg} className="my-info-header-image" />
            <div className="my-info-header-text">
              {t('myInfo.myInfo')}
            </div>
          </Col>
          <Col xs="9" style={{ paddingRight: 30 }}>
            <Row>
              <Col xs="2" className="menu-topTab menu-myInfoTab my-info-menu">
                <Button color="link" className="my-info-header-button active" onClick={() => changeTab(constants.MENU_NAVIGATION.myInfo)}>
                  {t('myInfo.myInfo')}
                </Button>
              </Col>
              <Col xs="2" className="menu-topTab menu-myInfoTab friends-menu">
                <Button color="link" className="my-info-header-button" onClick={() => changeTab(constants.MENU_NAVIGATION.friends)}>
                  {t('myInfo.friends')}
                </Button>
              </Col>
              <Col xs="2" className="menu-topTab menu-myInfoTab ignored-players-menu">
                <Button color="link" className={`my-info-header-button`} onClick={() => changeTab(constants.MENU_NAVIGATION.ignoredUsers)}>
                  {t('myInfo.ignoredPlayers')}
                </Button>
              </Col>
              <Col xs="2" className="menu-topTab menu-myInfoTab achievements-menu">
                {/* <Button color="link" className={`my-info-header-button ${achievementsNotification ? 'my-info-header-button-notification' : ''}`} onClick={() => changeTab(constants.MENU_NAVIGATION.archievements)}> */}
                <Button color="link" className={`my-info-header-button`} onClick={() => changeTab(constants.MENU_NAVIGATION.archievements)}>
                  {t('myInfo.achievements')}
                </Button>
              </Col>
              <Col xs="2" className="menu-topTab menu-myInfoTab results-menu-tab">
                <Button color="link" className="my-info-header-button" onClick={() => changeTab(constants.MENU_NAVIGATION.gameHistory)}>
                  {t('myInfo.results')}
                </Button>
              </Col>
              <Col xs="2" className="menu-topTab menu-myInfoTab weekly-statistics-menu">
                <Button color="link" className="my-info-header-button" onClick={() => changeTab(constants.MENU_NAVIGATION.weeklyStatus)}>
                  {t('myInfo.weeklyStatus')}
                </Button>
              </Col>
              <Col xs="2" className="menu-topTab menu-myInfoTab game-logs-menu">
                <Button color="link" className="my-info-header-button" onClick={() => changeTab(constants.MENU_NAVIGATION.gameLogs)}>
                  {t('myInfo.gameLogs')}
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <div className="my-info-body">
            
            <div className="my-info-body-left">

              <div className="main-data">
                {t('myInfo.registered2')}: {changeDateFormat(member.dateCreated) ? changeDateFormat(member.dateCreated) : t('myInfo.longTimeAgo')}

                <div className="main-data-table">
                  <div className="main-data-table-header">
                    <div className="main-data-table-header-cell">
                      {t('common.position')}
                    </div>
                    <div className="main-data-table-header-cell">
                      {t('common.parties')}
                    </div>
                    <div className="main-data-table-header-cell">
                      {t('common.wins')}
                    </div>
                    <div className="main-data-table-header-cell">
                      {t('common.points')}
                    </div>
                    <div className="main-data-table-header-cell">
                      {t('common.level')}
                    </div>
                  </div>
                  <div className="main-data-table-body">
                    <div className="main-data-table-body-cell">
                      {renderNum(member.position || 0)}
                    </div>
                    <div className="main-data-table-body-cell">
                      {renderNum(member.gamesPlayed)}
                    </div>
                    <div className="main-data-table-body-cell">
                      {renderNum(member.gamesWon)}
                    </div>
                    <div className="main-data-table-body-cell">
                      {renderNum(member.totalPoints)}
                    </div>
                    <div className="main-data-table-body-cell">
                      {renderNum(member.level)}
                    </div>
                  </div>
                </div>
              </div>

              <LevelProgress member={member} />

              <div>
                <GiftsHistory
                  getGiftsHistory={getGiftsHistoryFunction}
                  removeGift={removeGiftFunction}
                  giftsHistory={member.giftsHistory}
                  removedGiftsHistory={member.removedGiftsHistory}
                  gifts={gifts}
                  t={t}
                  notificationSettings={notificationSettings}
                  changeTab={changeTab}
                  fontMode={fontMode}
                />
              </div>

            </div>
            <div className="my-info-body-right">
              {t('myInfo.tournaments')}:
              <div className="my-tournaments-table">
                <div className="my-tournaments-table-header">
                  <div className="my-tournaments-table-header-title">
                    {t('tournaments.title')}
                  </div>
                  <div className="my-tournaments-table-header-pos">
                    {t('tournaments.position')}
                  </div>
                  <div className="my-tournaments-table-header-winningPot">
                    {t('tournaments.winningPot')}
                  </div>
                </div>
                <div className="my-tournaments-table-body">

                  {userTournamentsHistory && Object.keys(userTournamentsHistory).sort((a, b) => new Date(userTournamentsHistory[b].startDate) - new Date(userTournamentsHistory[a].startDate)).map(key => (
                    <div key={key} className="my-tournaments-table-body-row">
                      <div className="my-tournaments-table-body-row-title">
                        {userTournamentsHistory[key].name}
                      </div>
                      <div className="my-tournaments-table-body-row-pos">
                        {renderNum(userTournamentsHistory[key].finalPosition)}
                      </div>
                      <div className="my-tournaments-table-body-row-winningPot">
                        {renderNum(userTournamentsHistory[key].winAmount)}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  member: state.member || {},
  myTournamentsData: state.tournaments ? state.tournaments.myTournamentsData : {},
  //  leaderboardData: (state.leaderboard && state.leaderboard.leaderboard) ? state.leaderboard.leaderboard : {},
  gifts: state.rooms.gifts || {},
  userTournamentsHistory: state.member.userTournamentsHistory || {},
});

const mapDispatchToProps = {
  removeGiftFunction: removeGift,
  getGiftsHistoryFunction: getGiftsHistory,
  setScreenViewNew: setUserScreenViewNew,
};


export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(MyInfo));
